import { Component, Input } from '@angular/core';
import { WeatherForecastService } from '../weather-forecast.service';

@Component({
    selector: 'app-weather-forecast-icon',
    templateUrl: './weather-forecast-icon.component.html',
    styleUrls: ['./weather-forecast-icon.component.scss'],
    providers: [
        WeatherForecastService,
    ],
    standalone: false
})
export class WeatherForecastIconComponent {

  @Input() symbol: string;
  @Input() width: number;
  @Input() height: number;

  get weatherIcon() {
    return this.weatherForecastService.getIconSvg(this.symbol);
  }

  constructor(
    private weatherForecastService: WeatherForecastService,
  ) { }

}
